import React from 'react';

// import Banner from './01_banner';
// import Banners from '../../Molecules/banners';
// import Subtitle from './02_subtitle';
// import CardGrid from './03_cardGrid';
import { useLayoutEffect } from 'react';
import StepsSection from '../../Molecules/StepsSection/StepsSection';
import ContactForms from '../Controllers/ContactForms';
import Fleetsolutions from './04_fleetsolutions';
import Chargingprogram from './05_chargingprogram';
import FAQ from './Faq';
// import bannerImg from '../../Assets/bannersAssets/img_partition-c.8451ab5b16346320b46a (1).png';
import WhatsappIcon from './WhatsappIcon';
// import Calculator from './Calculator';

export default function Fleet() {
  useLayoutEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  return (
    <div>
      {/* <Banners
        title={`Fleet Solutions`}
        subtitle="The journey towards a 100% EV compliant world."
        className="business_banner"
        imgSrc={bannerImg}
      /> */}

      {/* <Subtitle /> */}
      {/* <CardGrid /> */}
      {/* <WhatsappIcon />
      <Calculator /> */}
      <Fleetsolutions />
      <Chargingprogram />
      <WhatsappIcon />
      <StepsSection />
      <FAQ />
      <ContactForms className="true"/> 
    </div>
  );
}
